"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLabelContentType = exports.isSensitivity = exports.isWarnable = exports.isCertifiable = exports.isUserSpecifiedIndicatorName = void 0;
function isUserSpecifiedIndicatorName(value) {
    return ['certified', 'warning', 'deprecated', 'stale', 'maintenance', 'sensitive_data'].includes(value);
}
exports.isUserSpecifiedIndicatorName = isUserSpecifiedIndicatorName;
function isCertifiable(value) {
    return ['datasource', 'database', 'table', 'tableWithCrass', 'virtualConnection', 'virtualConnectionTable', 'view'].includes(value);
}
exports.isCertifiable = isCertifiable;
function isWarnable(value) {
    return ['datasource', 'database', 'table', 'virtualConnection', 'virtualConnectionTable', 'flow', 'column'].includes(value);
}
exports.isWarnable = isWarnable;
function isSensitivity(value) {
    return ['datasource', 'database', 'table', 'virtualConnection', 'virtualConnectionTable', 'flow', 'column'].includes(value);
}
exports.isSensitivity = isSensitivity;
function isLabelContentType(value) {
    return isCertifiable(value) || isWarnable(value) || isSensitivity(value);
}
exports.isLabelContentType = isLabelContentType;
//# sourceMappingURL=LabelTypes.js.map